// @mui material components
import { styled, Theme } from '@mui/material/styles';

export default styled('div')(({ theme, readOnly }: { theme?: Theme | any, readOnly: boolean }) => {
  const {
    palette, typography: {
      fontFamily,
      h1,
      h2,
      h3,
      body1
    }
  } = theme;

  const { text } = palette;

  const white = '#ffffff'
  const dark = '#000000'

  const darkMode = theme.palette.mode === 'dark';

  return {
    '& .ql-toolbar': {
      borderRadius: '8px 8px 0 0',
      borderColor: 'rgba(255, 255, 255, 0.23) !important',

      backgroundColor: `${darkMode ? dark : white} !important`,
      '& .ql-picker, & .ql-stroke': {
        // stroke: `${darkMode ? white : dark} !important`
        // color: `${darkMode ? white : dark} !important`
      },
      '& .ql-picker-label': {
        color: `${darkMode ? white : dark} !important`
      },
      '& .ql-picker-options': {
        backgroundColor: `${darkMode ? dark : white} !important`,
        color: `${darkMode ? white : dark} !important`
      },

      '& .ql-hidden': {
        display: 'none'
      }
    },

    '& .ql-container': {
      borderColor: 'rgba(255, 255, 255, 0.23) !important',

      fontFamily,
      borderRadius: '0 0 8px 8px',

      '& .ql-tooltip': {
        display: 'none !important'
      }

    },

    '& .ql-editor': {
      ...(readOnly
        ? {
            padding: '0 !important'
          }
        : {}),

      minHeight: '150px',
      overflowY: 'auto',
      color: darkMode ? white : text.main,

      '& h1': {
        ...h1
      },

      '& h2': {
        ...h2
      },

      '& h3': {
        ...h3
      },

      '& p': {
        ...body1
      },

      '& ul li': {
        color: darkMode ? white : text.main
      }
    }
  };
});
